<script>
    import { link } from "svelte-routing";
    import HeaderIntro from "../components/basic/HeaderIntro.svelte";

    export let auth;

    let loginEmail = "";
    let loginPassword = "";
    function loginUser() {
      auth.signInWithEmailAndPassword(loginEmail, loginPassword)
          .then((userCredential) => {
            var user = userCredential.user;
          })
          .catch((error) => {
            alert("error: " + error.message);
            console.log(error);
            var errorCode = error.code;
            var errorMessage = error.message;
          });
    }

</script>


<main class="animate__fadeIn animate__animated">
    <HeaderIntro mainText={`Login`} subText={"Wenn du dich bereits auf Pausenheld registriert hast, kannst du dich hier mit deinen Anmeldedaten einloggen."}/>
    <form class="animate__fadeInUp animate__animated" on:submit|preventDefault={loginUser}>
        <div class="form-group">
            <label for="loginEmail">Email-Adresse</label>
            <input type="text" class="form-control" id="loginEmail" bind:value={loginEmail}>
        </div>
        <div class="form-group">
            <label for="loginPassword">Passwort</label>
            <input type="password" class="form-control" id="loginPassword" autocomplete="current-password" bind:value={loginPassword}>
        </div>
        <div class="bottomNotes text-muted passwortReset">
            <p><a href="#" on:click="{() => alert('Bitte schreibe eine kurze Email an info@pausenhelden.de und wir schicken dir einen Link zur Passwortrücksetzung zu.')}">Passwort vergessen?</a></p>
        </div>
        <button class="btn btn-specialOrange" type="submit">Login</button>
        <div class="bottomNotes text-muted">
            <p>Neu bei Pausenhelden?<br/><a href="/register" use:link>Hier</a> kannst du dich registrieren!</p>
        </div>
    </form>
</main>

<style>
    .passwortReset {
        text-align: end;
        opacity: 0.5;
        filter: grayscale(0.5);
    }
    label {
        padding-bottom: 5px;
    }
    form {
        max-width: 400px;
        margin: 0 auto;
        text-align: left;
        background: white;
        padding: 20px 30px;
        border-radius: 10px;
        box-shadow: 0 0 8px rgb(0 0 0 / 12%);
    }
    .form-group {
        margin: 22px 0;
    }
    .form-group:first-child {
        margin-top: 0;
    }
    .bottomNotes {
        margin-top: 25px;
        font-size: 13px;
        text-align: right;
    }
</style>